/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {remindTasks} from '../api'

export const useMutationRemindTasks = createReactQueryMutationHook('remindTasks', remindTasks)
